import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.vComp.$invalid && _ctx.vComp.$dirty)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.vComp.$errors, (error, index) => {
          return (_openBlock(), _createBlock("small", {
            class: "p-col-12",
            key: index
          }, _toDisplayString(_ctx.$t(_ctx.specificTranslateKeys && _ctx.specificTranslateKeys[error.$validator] ? _ctx.specificTranslateKeys[error.$validator] : `${_ctx.defaultMessageTranslateBasePath}.${error.$validator}`, { ...error.$params, ..._ctx.additionalTranslateParams })), 1))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}